import { createColor } from '@manakin/theme/lib/color';

const green = createColor('#c0e1d7');

export default green;
